import { Component, OnInit, Optional } from '@angular/core';
import { Posjet } from '@app/shared/models/posjet';
import { REGISTRIRANI_KORISNIK } from '@app/shared/models/types';
import { OpenArhivWindowActionUtil } from '@app/shared/util/open-arhiv-window-util';
import { DynamicFormService } from '@ntap/common';
import {
  ActionWindowParams,
  DEFAULT_ITEM_VIEW,
  EMPTY_ACTION_RESULT,
  ItemActionResult,
  ItemUtil,
  ItemView,
  ItemViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ViewResult,
  ViewResultListener,
  ViewState,
  ViewWindow,
  ViewWindowComponent,
  WindowRegistry
} from '@ntap/core';
import { PrimeNGButtonNewItemViewActionComponent } from '@ntap/primeng';
import { filter, first, map, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'app-open-korisnik-citaonice',
  templateUrl: './open-korisnik-citaonice.component.html',
  providers: [
    {
      provide: ViewResultListener,
      useExisting: ViewWindowComponent
    },
    {
      provide: WindowRegistry,
      useClass: WindowRegistry
    },
    {
      provide: DynamicFormService,
      useClass: DynamicFormService
    }
  ]
})
export class OpenKorisnikCitaoniceComponent
  extends PrimeNGButtonNewItemViewActionComponent
  implements OnInit
{
  static REGISTRIRANI_KORISNIK_VIEW_NAME = 'noviRegistriraniKorisnikItem';

  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    protected listViewProvider: ListViewProviderDirective<ListView>,
    protected itemViewProvider: ItemViewProviderDirective<ItemView>
  ) {
    super(notificationService, windowRegistry, window, listViewProvider);
  }

  ngOnInit() {
    this.log('onInitCalled!');
  }

  protected override doExecuteWithItem(
    item: any
  ): Observable<ItemActionResult> {
    this.log('doExecuteWithItem' + JSON.stringify(item));
    return this.itemViewProvider.item$.pipe(
      first(),
      switchMap((item) => {
        const korisnikCitaoniceId = (item as Posjet)[
          'en~posjet~registrirani_korisnik_id'
        ];

        const itemm: any = {
          $itemType: REGISTRIRANI_KORISNIK,
          $mainType: REGISTRIRANI_KORISNIK,
          $parentId: korisnikCitaoniceId,
          $parentType: REGISTRIRANI_KORISNIK,
          'en~registrirani_korisnik~id': korisnikCitaoniceId
        };

        const itemProps =
          (korisnikCitaoniceId && {
            $id: korisnikCitaoniceId,
            $type: REGISTRIRANI_KORISNIK,
            $itemType: REGISTRIRANI_KORISNIK
          }) ||
          {};

        const keyItem = ItemUtil.extractItemKey(itemm);

        const viewState = Object.assign({}, keyItem, itemProps);

        return this.doOpenWindow(viewState).pipe(
          filter((viewResult: any) => this.acceptResult(viewResult)),
          map(
            (viewResult) =>
              new ItemActionResult(EMPTY_ACTION_RESULT, viewResult.viewData[0])
          )
        );
      })
    );
  }

  private doOpenWindow(viewState: ViewState): Observable<ViewResult> {
    return OpenArhivWindowActionUtil.open(
      this.getActionWindowParams(),
      viewState
    );
  }

  protected override getActionWindowParams(): ActionWindowParams {
    this.doSetDefaultActionViewName();
    const actionWindowParams = OpenArhivWindowActionUtil.createParams(
      this.action,
      this.windowRegistry,
      'noviRegistriraniKorisnikItem'
    );

    return actionWindowParams;
  }

  private doSetDefaultActionViewName() {
    if (!this.action.$openViewName) {
      this.action.$openViewName = DEFAULT_ITEM_VIEW;
    }
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.itemViewProvider.item$.pipe(
      map((item: any) => {
        return item['en~posjet~id'] == 0;
      })
    );
  }
}
